export default __webpack_public_path__ + "static/media/img003.67a905d5.png";